<template>
    <a-form-item label="京东邮寄">
        <a-row :gutter="48">
            <a-col :span="24">
                <a-form-item label="状态">
                    <a-switch checked-children="开启" un-checked-children="关闭" :checkedValue="1" :unCheckedValue="2"
                        v-model:checked="state.shipp_rule[1].status" @change="inputChange"></a-switch>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item label="京东账号">
                    <a-select allow-clear v-model:value="state.shipp_rule[1].logistics_rule_id" placeholder="请选择"
                        @change="inputChange" option-filter-prop="label">
                        <a-select-option v-for="(item, index) in state.ruleJDList" :key="index" :value="item.id"
                            :label="item.name">{{
                                item.name }}</a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item label="包邮减免">
                    <a-input placeholder="请输入金额" v-model:value="state.shipp_rule[1].free_money" style="width: 150px"
                        @change="inputChange" addonAfter="元"></a-input>（超过此金额的需要补差价）
                </a-form-item>
            </a-col>
        </a-row>
    </a-form-item>
    <a-form-item label="顺丰邮寄">
        <a-row :gutter="48">
            <a-col :span="24">
                <a-form-item label="状态">
                    <a-switch checked-children="开启" un-checked-children="关闭" :checkedValue="1" :unCheckedValue="2"
                        v-model:checked="state.shipp_rule[2].status" @change="inputChange"></a-switch>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item label="顺丰账号">
                    <a-select allow-clear v-model:value="state.shipp_rule[2].logistics_rule_id" placeholder="请选择"
                        @change="inputChange" option-filter-prop="label">
                        <a-select-option v-for="(item, index) in state.ruleSFList" :key="index" :value="item.id"
                            :label="item.name">{{
                                item.name }}</a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item label="包邮减免">
                    <a-input placeholder="请输入金额" v-model:value="state.shipp_rule[2].free_money" style="width: 150px"
                        @change="inputChange" addonAfter="元"></a-input>（超过此金额的需要补差价）
                </a-form-item>
            </a-col>
        </a-row>
    </a-form-item>
</template>
<script lang="ts" setup>
import { reactive, watch, onMounted } from 'vue';
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { IShippingRule } from '@/components/shippingRule/shippingRule'
const emit = defineEmits(['update:value'])
const props = defineProps({
    value: {
        type: Object,
        default: null,
    },
    fwsPtid: {//所属服务商
        type: Number,
        default: 0
    },
    customerPlatformId: {//地址平台传这个
        type: Number,
        default: 0
    },
    kezhangPlatformId: {//刻章平台传这个
        type: Number,
        default: 0
    },
    cancelPlatformId: {//注销订单传这个
        type: Number,
        default: 0
    }
})

interface stateType {
    loading: boolean,
    ruleJDList: any[]
    ruleSFList: any[]
    shipp_rule: IShippingRule
}
const state = reactive<stateType>({
    loading: false,
    ruleJDList: [],
    ruleSFList: [],
    shipp_rule: {
        1: {
            status: 2,
            logistics_rule_id: null,
            free_money: 0,
        },
        2: {
            status: 2,
            logistics_rule_id: null,
            free_money: 0,
        }
    }
})
onMounted(() => {
    getLogisticsRule()
})
const getLogisticsRule = () => {
    state.loading = true
    let requestParam = {
        url: '/admin/v1/logisticsRule/getLogisticsRule',
        method: 'post',
        data: {
            fws_ptid: props.fwsPtid,
            customer_platform_id: props.customerPlatformId,
            kezhang_platform_id: props.kezhangPlatformId,
            cancel_platform_id: props.cancelPlatformId
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            state.ruleJDList = res.data.jd_list
            state.ruleSFList = res.data.sf_list
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.loading = false
        })
}
watch(() => props.value, (val) => {
    if (val) {
        Object.assign(state.shipp_rule, val)
    }
}, {
    deep: true,
    immediate: true,
})
watch(
    () => [props.fwsPtid, props.customerPlatformId, props.kezhangPlatformId, props.cancelPlatformId],
    ([newFwsPtid, newCustomerId, newKezhangId, newCancelId],
        [oldFwsPtid, oldCustomerId, oldKezhangId, oldCancelId]) => {
        // 任意一个变化都会进入这里
        getLogisticsRule()
    }
)
const inputChange = () => {
    emit('update:value', state.shipp_rule)
}
</script>
